import React, { useState } from 'react';
import {
  Block,
  BlockTitle,
  ListInput,
  List,
  Button,
  ListItem
} from 'framework7-react';
import II18 from '../translate/II18';
import ReactCodeInput from 'react-code-input';
import PropTypes from 'prop-types';

export default function PinCodeBlock(props) {
  const [code, setCode] = useState('');
  return (
    <div
      id="pinCodeBlock"
      data-testid="homePinCodeBlock"
      style={{ marginTop: props.topMargin }}
    >
      <BlockTitle
        medium
        style={{
          textAlign: 'center',
          whiteSpace: 'break-spaces',
          fontSize: props.titleFontSize || 20
        }}
      >
        <II18>{props.title}</II18>
      </BlockTitle>
      <Block strong={!props.noLines}>
        <div style={{ display: 'flex', justifyContent: 'center' }}>
          {props.textAsInput ? (
            <List
              noHairlinesMd
              style={{ width: '100%', maxWidth: 350, margin: '0 auto' }}
            >
              <ListInput
                name={'pin_code'}
                outline
                required
                floatingLabel
                type="text"
                clearButton
                value={code}
                onChange={e => setCode(e.target.value)}
                autoComplete={props.oneTimeCode && 'one-time-code'}
              />
              <ListItem style={{ display: 'flex', justifyContent: 'center' }}>
                <Button
                  className={'scan-portal'}
                  fill
                  onClick={() => props.verifyCodeChange(code)}
                >
                  {II18.get('title_confirm')}
                </Button>
              </ListItem>
            </List>
          ) : (
            <ReactCodeInput
              name={'pin_code'}
              type="number"
              fields={props.fieldsCount || 4}
              onChange={props.verifyCodeChange}
              isValid={!props.showPinIsWrongMessage}
              inputMode={'numeric'}
              autoComplete={props.oneTimeCode && 'one-time-code'}
            />
          )}
        </div>
      </Block>
      {props.showPinIsWrongMessage && (
        <p
          data-testid="homePinCodeBlockFailMessage"
          style={{ color: '#b11313', textAlign: 'center' }}
        >
          <II18>home_pincode_failed</II18>
        </p>
      )}
    </div>
  );
}

PinCodeBlock.propTypes = {
  fieldsCount: PropTypes.number,
  title: PropTypes.string,
  topMargin: PropTypes.number,
  showPinIsWrongMessage: PropTypes.bool,
  oneTimeCode: PropTypes.bool,
  noLines: PropTypes.bool,
  verifyCodeChange: PropTypes.func,
  titleFontSize: PropTypes.number,
  textAsInput: PropTypes.bool
};
